import Alpine from 'alpinejs';
import config from '@src/js/config';
import { getQueryParam } from '@src/js/utils/http';
Alpine.data("auth", () => ({
    state: 'login',
    email: '',
    password: '',
    baseUrl: config.API_URL,
    error: {},
    loginRedirectUrl: config.APP_URL,
    loginFailureUrl: config.APP_URL + 'auth.html?state=login&error=true',
    init() {
        const params = new URLSearchParams(window.location.search);
        const urlState = getQueryParam('state');
        const validStates = ['login', 'signup', 'forgotPassword'];
        if (urlState && validStates.includes(urlState)) {
            this.state = urlState;
        }
        if (params.get('error') === 'true') {
            this.error.message = 'Login failed. Please try again.';
        }
        if (params.get('success') === 'true') {
            window.location.href = this.loginRedirectUrl;
        }
    },
    async submit() {
        this.error.message = '';
        if (!this.validateFields())
            return;
        const endpoint = this.baseUrl + 'account' +
            (this.state === 'signup' ? '/register' : '/forgot-password');
        const payload = {
            email: this.email,
            ...(this.state !== 'forgotPassword' && { password: this.password }),
            returnUrl: window.location.href
        };
        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                const error = await response.json();
                this.error = error.message || 'An error occurred';
                return;
            }
            if (this.state === 'signup') {
                const user = await response.json();
                window.location.href = '/confirm-signup.html?userId=' + encodeURIComponent(user._id);
            }
            else {
                this.setState('login');
            }
        }
        catch (err) {
            console.error(err);
            this.error.message = 'Failed to connect to the server. Please try again later.';
        }
    },
    validateFields() {
        if (!this.email || !this.email.includes('@')) {
            this.error.message = 'Please enter a valid email address.';
            return false;
        }
        if ((this.state === 'login' || this.state === 'signup') && (!this.password || this.password.length < 6)) {
            this.error.message = 'Password must be at least 6 characters long.';
            return false;
        }
        return true;
    },
    setState(newState) {
        this.state = newState;
        this.email = '';
        this.password = '';
        this.error.message = '';
    }
    // add more methods here
}));
